import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setInitialPageIndex } from './search-results.actions';

export class PageIndexUrlSerializer implements UrlPartSerializer {
  constructor(readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const index = parseInt(urlValue, 10) || 0;
    return setInitialPageIndex({
      pageIndex: index,
    });
  }

  serialize(state: AppState): string {
    return state.results.searchResults.pageIndex.toString();
  }
}
